import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DownloadComponent } from '../download/download.component';
import { utilReducer } from './utils.action';
import { initialUtilState } from './utils.state';
import { UtilsEffects } from './utils.effects';
import { ApplicationService } from '../../shared/services/application.service';

@NgModule({
    declarations: [DownloadComponent],
    imports: [
        CommonModule,
        RouterModule,
        StoreModule.forFeature('util', utilReducer, {
            initialState: initialUtilState
        }),
        EffectsModule.forFeature([UtilsEffects])
    ],
    exports: [DownloadComponent],
    providers: [ApplicationService]
})
export class UtilModule {}
